<div class="trending">
  <div class="trending-title">
    <p class="title">{{ I18ns.home.trending }}</p>

    <span (click)="showLangs = !showLangs" class="lang-picker">
      {{ store.defaultLang()?.flag || store.defaultLang()?.tag || I18ns.home.filter }}

      <div *ngIf="showLangs" class="lang-options">
        <div (click)="pickLang(null)" class="options">{{ I18ns.addTheme.all }}</div>
        <div (click)="pickLang({tag: 'World', flag: undefined})" class="options">{{ I18ns.addTheme.noLang }}</div>
        <div (click)="pickLang(lang)" *ngFor="let lang of flagList" class="options">
          {{ lang.flag }} {{ lang.tag }}
        </div>
      </div>
    </span>

  </div>
  <a (click)="goToTheme(theme)" *ngFor="let theme of themes" [routerLink]="['/k', theme.id]" class="theme">
    <span>{{ theme.name }}</span>
    <div>
      <!--      <img *ngIf="getFlag(theme.lang)" [src]="getFlag(theme.lang)" alt="flag" class="flag" />-->
      {{ getFlag(theme.lang) }}
    </div>
  </a>

  <p (click)="showMoreThemes()" *ngIf="themes.length < themesCount" class="show-more-themes">
    {{ I18ns.home.showMoreThemes }} +
  </p>
</div>
